import { render, staticRenderFns } from "./CredorCliente.vue?vue&type=template&id=9db6f2ac"
import script from "./CredorCliente.vue?vue&type=script&lang=js"
export * from "./CredorCliente.vue?vue&type=script&lang=js"
import style0 from "./CredorCliente.vue?vue&type=style&index=0&id=9db6f2ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports